<div class="container" style="margin-top: 2em;">

    <h2 class="text-center">Contact Jon Ray Building Ltd</h2><!-- removed class mb-5-->

    <div class="card align-content-center text-center mx-auto d-block image">
      <img src="/assets/images/Van.jpg" class="card-img-top img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent">
    </div>

    <div class="row" style="margin-bottom:2em;">

      <div class="col-md-6 offset-md-3 highlight" *ngIf="messageSent">
        Thank you for your enquiry and we will endeavour to respond within the next working day.
      </div>

      <div class="col-md-8 offset-md-2" *ngIf="!messageSent">

        <p>Please complete the following form which will send an email to Jon Ray Building Ltd.</p>

        <form [formGroup]="FormData" (ngSubmit)="sendEmail($event)" class="contact-form"><!-- onSubmit(FormData.value) works for mailThis-->
          <div class="form-group">
            <label for="from_name">Your name</label>
            <input
              type="text"
              class="form-control"
              name="from_name"
              placeholder="Full Name"
              formControlName="Fullname"
            /><!-- Fullname -->
          </div>

          <div class="form-group">
            <label for="from_email">Your email address</label>
            <input
              type="email"
              class="form-control"
              name="from_email"
              placeholder="Enter your email"
              formControlName="Email"
            />
          </div>

          <div class="form-group">
            <label for="from_phone">Your phone number</label>
            <input
              type="text"
              class="form-control"
              name="from_phone"
              placeholder="Enter your phone"
              formControlName="Phone"
            />
          </div>

          <div class="form-group">
            <label for="message">Details of enquiry</label>
            <textarea class="form-control" formControlName="Comment" name="message">
            </textarea>
          </div>
          <button type="submit" class="btn btn-primary" [disabled]="!FormData.valid || sending">
            Send
          </button>

        </form>
      </div>
    </div>
  </div>
